<script lang="ts">
  import SendRecognition from "@/Pages/Plans/Recognitions/SendRecognition.svelte"

  export let plan
  export let onboarding

  const path = window.location.pathname
  const activeItemCSS = "text-active-header border-active-header"
  const defaultCSSClass =
    "whitespace-no-wrap pb-3 md:pb-6 px-2 lg:px-3 xl:px-4 border-b-2 font-medium text-xs md:text-sm md:leading-5 hover:text-gray-700 hover:border-gray-300 focus:outline-none focus:text-gray-700 focus:border-gray-300 text-inactive-header border-transparent"

  let current = ""
  const inactiveItemCSS = ""

  if (/^\/plans\/\d+\/recognitions/.test(path)) {
    current = "recognitions"
  } else if (/^\/plans\/\d+\/community/.test(path)) {
    current = "community"
  } else if (/^\/plans\/\d+$/.test(path)) {
    current = "plan"
  }
</script>

{#if !["courses", "resources"].includes(current)}
  <header class="bg-white shadow">
    <div class="max-w-7xl mx-auto px-3 sm:px-6 flex justify-between">
      <div class="lg:grid col-gap-2 w-full header-cont">
        <div class="flex items-center py-4">
          <img
            class="inline-block h-10 w-10 sm:h-14 sm:w-14 rounded-full shadow"
            src={plan.logo_url}
            alt=""
          />
          <h1
            class="text-left w-full text-2xl sm:text-3xl font-bold leading-tight text-gray-900 ml-2"
          >
            {plan.name}
          </h1>
          {#if onboarding?.completed_onboarding}
            <div
              class="inline-flex lg:hidden send-recognition justify-end items-start"
            >
              <SendRecognition plan_id={plan.id} class=" h-10" />
            </div>
          {/if}
        </div>
        <div class="flex justify-center items-end mx-auto px-0">
          <div class="border-b border-gray-200 w-full">
            <nav class="-mb-px flex justify-between">
              <a
                data-name="plan-onepage-link"
                class={defaultCSSClass}
                class:active={current === "plan"}
                on:click={() => (current = "plan")}
                href="/plans/{plan.id}"
              >
                One Page View
              </a>
              <a
                data-name="plan-recognitions-link"
                class={defaultCSSClass}
                class:active={current === "recognitions"}
                on:click={() => (current = "recognitions")}
                href="/plans/{plan.id}/recognitions"
              >
                Recognitions
              </a>
              <a
                data-name="plan-community-link"
                class={defaultCSSClass}
                class:active={current === "community"}
                on:click={() => (current = "community")}
                href="/plans/{plan.id}/community"
              >
                Community
              </a>
            </nav>
          </div>
        </div>
        {#if onboarding?.completed_onboarding}
          <div
            class="hidden lg:inline-flex items-center send-recognition justify-end"
          >
            <div class="lg:ml-auto inline-block">
              <SendRecognition plan_id={plan.id} class=" h-10" />
            </div>
          </div>
        {/if}
      </div>
    </div>
  </header>
{/if}

<style>
  @media (max-width: 640px) {
    .send-recognition > div {
      margin-left: auto;
      margin-right: auto;
    }
  }
  @media (min-width: 640px) {
    .header-cont {
      grid-template-columns: 31% 50% 18%;
    }
  }
  @media (max-width: 1024px) {
    .header-cont {
      grid-template-columns: 20rem 1fr;
    }
  }

  .active {
    --tw-text-opacity: 1;
    color: rgba(77, 74, 223, var(--tw-text-opacity));
    --tw-border-opacity: 1;
    border-color: rgba(77, 74, 223, var(--tw-border-opacity));
  }
</style>
